import { Status } from "../../newLayout/page/components/Status/Status";

/**
 * Purchase order status for list and board: shows live shipment status while in transit.
 *
 * @param {{ order: { status?: string, shipment_sub_status?: object, shipments?: Array<object> } }} props
 * @return {*}
 */
export function PurchaseOrderShipmentSubStatus({ order }) {
  const sub = order?.shipment_sub_status;
  const statusName = sub?.label ?? order?.status;
  const shipments = order?.shipments ?? [];
  const tooltip =
    sub && shipments.length > 0
      ? shipments
          .map(item => `${item.name || "Shipment"}: ${item.status_label || item.status || "—"}`)
          .join("\n")
      : undefined;
  const suffix = sub?.other_count > 0 ? ` +${sub.other_count} more` : "";

  return (
    <span title={tooltip}>
      <Status statusName={statusName} palette="journey" />
      {suffix}
    </span>
  );
}
